import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Dialog } from '@node-space/ui-components'
import { OnceOffTransactionExportForm } from 'components/export/onceOff/OnceOffTransactionExportForm'
import { OnceOffExportContextProvider } from 'contexts/onceOffExportContext'
import { useOnceOffCardTransactionsExport } from 'hooks/transactionsExport/onceOff/useOnceOffCardTransactionsExport'
import {
  AmplitudeEvent,
  AmplitudeEventAction,
  AmplitudeEventCategory,
} from 'utils/amplitude/amplitudeEvents'
import track from 'utils/tracker'

interface CardTransactionExportModalProps {
  handleClose: () => void
  cardId?: string
}

export const CardTransactionExportModal = ({
  handleClose,
  cardId,
}: CardTransactionExportModalProps) => {
  const { t } = useTranslation()

  useEffect(() => {
    track.Amp.track(AmplitudeEvent.EXPORT_TRANSACTION_INITIATE, {
      category: AmplitudeEventCategory.MERCHANT_PORTAL,
      action: AmplitudeEventAction.LOAD,
      page: 'cards',
    })
  }, [])

  const exportValues = useOnceOffCardTransactionsExport({ handleClose, cardId })

  const CancelButton = (
    <Button key="cancel" onClick={handleClose} variant="secondary">
      {t('exports.cancel')}
    </Button>
  )

  const isCustomDateRangeSelected =
    exportValues?.formValues?.selectedDateOptionName ===
    exportValues?.exportCustomDateOptions?.customDateRange?.name

  const hasNoDatesProvided = !exportValues?.dateValue?.from && !exportValues?.dateValue?.to

  const isExportDisabled = isCustomDateRangeSelected && hasNoDatesProvided

  const ExportButton = (
    <Button
      key="exportToEmail"
      onClick={exportValues?.handleTransactionExportToEmail}
      loading={exportValues?.isExporting}
      disabled={isExportDisabled}
    >
      {t('exports.exportToEmail')}
    </Button>
  )

  return (
    <Dialog
      title={t('exports.cardModalTitle')}
      type="utility"
      open
      onClose={handleClose}
      ActionButtons={[ExportButton, CancelButton]}
    >
      <OnceOffExportContextProvider value={exportValues}>
        <OnceOffTransactionExportForm allowBalanceReport={false} />
      </OnceOffExportContextProvider>
    </Dialog>
  )
}
